import p1 from "../img/person1.png";
import p2 from "../img/person2.png";
import p3 from "../img/person3.png";
import p4 from "../img/person4.png";
const testimonialData = [
  {
    id: 1,
    content:
      "Very good experience. Got the settlement done in less than 24 hours.",
    name: "rahul gupta",
    city: "delhi",
    img: p1,
    view: "lg",
  },
  {
    id: 2,
    content:
      "Thank you so much for the amazing service, Special thanks to Mr. Rais Shaikh.",
    name: "Somnath Mane",
    city: "pune",
    img: p2,
    view: "lg",
  },
  {
    id: 3,
    content:
      "Hassle free insurance & quick response. Absolutely best insurance company ever",
    name: "vinil kumar",
    city: "hyderabad",
    img: p3,
    view: "lg",
  },
  {
    id: 1,
    content:
      "Go for ACKO General Insurance if you want a 'WOW'! settlement of your claims.",
    name: "Vikas Gupta    ",
    city: "lucknow",
    img: p4,
    view: "sm",
  },
];
export default testimonialData;